module.exports = __webpack_public_path__ + "img/logo.071e6820.png";